import React from "react";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";

import {
  Callout,
  Spinner,
  H5
} from "@blueprintjs/core";


import KeyData from "../../Structure/KeyData";
import EventCounterEditor from "./EventCounterEditor";
import EventCounterEvolution from "./EventCounterEvolution";
import EventCounterCreator from "./EventCounterCreator";

export const eventCounterLevel = {
  SUCCESS: 0,
  INFO: 1,
  WARNING: 2,
  ERROR: 3
}

class KeyValue extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editorOpen: false };
  }

  render() {
    return (<div>
      <KeyData
        className="noprint"
        label={this.props.data.info.title}
        data={this.props.data.value !== null ? this.props.data.value : 0}
        onCogClick={localStorage.getItem('perm_admin') === 'true' ? () => this.setState({ editorOpen: true }) : undefined}
        onChartClick={() => this.setState({ chartOpen: true })}
        unit={this.props.data.base !== 1 ? "%" : ""}
        details={this.props.data.base !== 1 ? "(" + this.props.data.cnt + "/" + this.props.data.base + ")" : null}
      />
      <span className="onlyPrint flexbox-left"><H5 style={{ display: "inline-block" }}>{this.props.data.info.title} :</H5> {this.props.data.value} {this.props.data.base !== 1 ? "%" : ""}</span>
      <EventCounterEditor
        open={this.state.editorOpen}
        data={this.props.data}
        onClose={() => this.setState({ editorOpen: false })}
        onUpdate={() => this.props.onUpdate()}
      />
      <EventCounterEvolution
        open={this.state.chartOpen}
        data={this.props.data}
        onClose={() => this.setState({ chartOpen: false })}
        urlsearchparams={this.props.urlsearchparams}
      />
    </div>);
  }
}

export default class KeyValues extends React.Component {
  constructor() {
    super();
    this.state = {
      success: [],
      info: [],
      warning: [],
      error: [],
      loading: true,
      unauthorized: false
    };
    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    if (localStorage.getItem('perm_activity') === "true") {
      this.setState({ loading: true });
      if (this.props.urlsearchparams !== undefined) {
        var success = [];
        var info = [];
        var warning = [];
        var error = [];
        var i = 0;

        authenticatedGetFetch('/activity/keyvalues?' + this.props.urlsearchparams,
          (response) => {
            for (var kv of response) {
              switch (kv.info.level) {
                case eventCounterLevel.SUCCESS:
                  success.push(<KeyValue key={"kv" + i++} data={kv} urlsearchparams={this.props.urlsearchparams} onUpdate={() => this.fetchData()} />);
                  break;
                case eventCounterLevel.INFO:
                  info.push(<KeyValue key={"kv" + i++} data={kv} urlsearchparams={this.props.urlsearchparams} onUpdate={() => this.fetchData()} />);
                  break;
                case eventCounterLevel.WARNING:
                  warning.push(<KeyValue key={"kv" + i++} data={kv} urlsearchparams={this.props.urlsearchparams} onUpdate={() => this.fetchData()} />);
                  break;
                case eventCounterLevel.ERROR:
                  error.push(<KeyValue key={"kv" + i++} data={kv} urlsearchparams={this.props.urlsearchparams} onUpdate={() => this.fetchData()} />);
                  break;
                default:
                  break;
              }
            }
            this.setState({
              success: success,
              info: info,
              warning: warning,
              error: error,
              loading: false
            });
          });
      } else
        this.setState({ loading: false });
    } else {
      this.setState({ unauthorized: true });
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {
    if (this.state.unauthorized) {
      return <Callout icon="key" title={<Trans>key values</Trans>} intent="warning">
        <Trans>you are not allowed to visualize element:</Trans> <Trans>key values</Trans><br /><Trans></Trans><Trans>for any change of your permissions please contact an administrator</Trans>
      </Callout>;
    }
    else if (this.state.loading)
      return <Callout icon="key" title={<Trans>key values</Trans>}>
        <Spinner/>
      </Callout>;
    else {
      var ret = [];
      if (this.state.success.length > 0)
        ret.push(
          <Callout key="skv" intent="success">
            <div className="flexbox-left noprint">
              {this.state.success}
            </div>
            <div className="onlyPrint">
              {this.state.success}
            </div>
          </Callout>
        );
      if (this.state.info.length > 0)
        ret.push(
          <Callout key="ikv" intent="primary">
            <div className="flexbox-left noprint">
              {this.state.info}
            </div>
            <div className="onlyPrint">
              {this.state.info}
            </div>
          </Callout>
        );
      if (this.state.warning.length > 0)
        ret.push(
          <Callout key="wkv" intent="warning">
            <div className="flexbox-left noprint">
              {this.state.warning}
            </div>
            <div className="onlyPrint">
              {this.state.warning}
            </div>
          </Callout>
        );
      if (this.state.error.length > 0)
        ret.push(<Callout key="ekv" intent="danger">
          <div className="flexbox-left noprint">
            {this.state.error}
          </div>
          <div className="onlyPrint">
            {this.state.error}
          </div>
        </Callout>
        );

      if (ret.length > 0 && localStorage.getItem('perm_admin') === 'true')
        ret.unshift(<EventCounterCreator key="ecc" onCreate={() => this.fetchData()} />)

      return ret.length > 0 ? (<Callout icon="key" title={<Trans>key values</Trans>}>{ret}</Callout>) : null;
    }
  }
}